"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomApiFunction = void 0;
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
const CustomApiAdapter_1 = require("../../storyV2/adapter/CustomApiAdapter");
const FunctionBase_1 = require("../../storyV2/function/FunctionBase");
const FunctionUtil_1 = require("../../storyV2/function/FunctionUtil");
const JsonUtil_1 = require("../../cutil/JsonUtil");
const Settings_1 = require("../../kernel/Settings");
const qs_1 = __importDefault(require("qs"));
class CustomApiFunction extends FunctionBase_1.FunctionBase {
    constructor() {
        super(...arguments);
        this.props = new CustomApiAdapter_1.CustomApiProps();
    }
    async run(input, identityInfo, variableList = []) {
        const streamResponse = await this.socketRestClient.requestRestGlobal(topic => {
            return this.httpDataSource(input, topic, identityInfo, variableList);
        }, "customApi", identityInfo);
        return new FunctionBase_1.FuncResponse(FunctionBase_1.FuncResponseType.CUSTOM_API, streamResponse);
    }
    async httpDataSource(input, pubsub_topic, identityInfo, variableList = []) {
        if ((0, is_blank_1.default)(this.props.url)) {
            return Promise.reject("url is blank");
        }
        let url = FunctionUtil_1.FunctionUtil.customApiUrlReplace(input, this.props.url, variableList);
        const headers = FunctionUtil_1.FunctionUtil.customApiHeadersReplace(input, this.authStore.state.brainToken, this.authStore.state.guestToken, this.props.headerList, variableList);
        let bodyParam = FunctionUtil_1.FunctionUtil.customApiBodyParamsReplace(input, this.props.bodyParam, variableList);
        /// 如果是 api 服务器，添加 pubsub_topic
        if (url?.startsWith(Settings_1.settings.API)) {
            return this.sendRequestWithPubsubTopic(url ?? "", this.props.method ?? "get", headers, bodyParam, pubsub_topic, identityInfo);
        }
        else {
            return this.sendRequest(url ?? "", this.props.method ?? "get", headers, bodyParam, identityInfo);
        }
    }
    async sendRequest(url, method, headers, body, identityInfo) {
        return this.brainClient.global.request(url, method, headers, body, FunctionUtil_1.FunctionUtil.createAbortUuid(identityInfo));
    }
    async sendRequestWithPubsubTopic(url, method, headers, body, pubsub_topic, identityInfo) {
        return new Promise((resolve, reject) => {
            if (method === "get") {
                const [path, search] = url.split("?");
                const params = qs_1.default.parse(search);
                const newParams = {
                    ...params,
                    pubsub_topic,
                };
                const newUrl = [path, qs_1.default.stringify(newParams)].join("?");
                return this.sendRequest(newUrl, method, headers, undefined, identityInfo)
                    .then(res => {
                    /// 按照需求 202 和 504 需要忽略结果或者错误
                    if (res.isSuccess || res.status === 504) {
                        resolve(res);
                    }
                    else {
                        // 这里会 throw 一个错误，需要在 catch 中捕获
                        return res.validate();
                    }
                })
                    .catch(error => reject(error));
            }
            else {
                const param = JsonUtil_1.JsonUtil.parse(body);
                const newParams = {
                    ...param,
                    pubsub_topic,
                };
                return this.sendRequest(url, method, headers, newParams, identityInfo)
                    .then(res => {
                    /// 按照需求 202 和 504 需要忽略结果或者错误
                    if (res.isSuccess || res.status === 504) {
                        resolve(res);
                    }
                    else {
                        // 这里会 throw 一个错误，需要在 catch 中捕获
                        return res.validate();
                    }
                })
                    .catch(error => reject(error));
            }
        });
    }
}
exports.CustomApiFunction = CustomApiFunction;
